import { fetchUnread } from '@components/Chat/chatApi'
import { queryKeys } from '@lib/queryKeys'
import type { GetChatUnreadResponse } from '@orbit/api-types'
import { useQuery } from '@tanstack/react-query'

/**
 * My unread count in a trip's Chat, for the Chat button's badge. Fetched on every
 * mount and focus; a `chat_updated` in a room this browser holds invalidates it, and the
 * Chat itself writes the count each read mark returns.
 */
export const useChatUnread = (tripId: string | undefined) =>
	useQuery<GetChatUnreadResponse>({
		queryKey: queryKeys.chatUnread(tripId),
		queryFn: () => {
			if (!tripId) throw new Error('Trip ID is required')
			return fetchUnread(tripId)
		},
		enabled: !!tripId,
		staleTime: 0,
		refetchOnWindowFocus: true,
		retry: 1,
	})
